<div class="language-selection">
    <h1 class="language-selection-header tapestry-body body--xxl bold">
        {{ 'platform.global-nav.language-selection.title' | translate }}
    </h1>
    <mat-divider />
    <form
        class="language-selection-form"
        [formGroup]="form"
        (ngSubmit)="saveChanges()"
    >
        <p class="language-selection-form-description">
            {{
                'platform.global-nav.language-selection.description' | translate
            }}
        </p>
        <div class="language-selection-form-body">
            <language-selector
                class="language-selection-form-body-select"
                [selectLabel]="
                    'platform.global-nav.language-selection.label' | translate
                "
                [size]="SelectSize.Small"
                [isRequired]="true"
                formControlName="language"
            />
            <div class="language-selection-form-body-actions">
                <tapestry-button
                    [color]="ButtonColor.Primary"
                    [text]="
                        'text.common-terms.save-changes.sentence-case'
                            | translate
                    "
                    [disabled]="saving()"
                    [loading]="saving()"
                    trackingName="language-selection-save-button"
                    piTesting="language-selection-save-button"
                />
            </div>
        </div>
    </form>
</div>
